import { Radio as MuiRadio, RadioProps } from '@mui/material';
import { styled } from '@mui/system';

const StyledRadio = styled(MuiRadio)(({ theme }) => ({
	color: theme.palette.borderPrimary.main,
	'&.Mui-checked': {
		color: theme.palette.common.black,
	},
}));

const Radio = (props: RadioProps) => {
	return <StyledRadio {...props} />;
};

export default Radio;
